import { CardIcon } from './CardIcon';

/**
 * author: Rynco Li
 * id AB226798-9B8A-4929-8880-6665C1114776
 * name card
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card.svg
 * tags
 * - Form 
 */
export const ButtonIcon = CardIcon;
export default ButtonIcon